import { Component } from '@angular/core';
import { EcapTranslateService } from '@ecap3/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
    constructor(private translateService: EcapTranslateService) {}
}
